<template>
  <div
    class="w-100 bg-white d-flex flex-column justify-content-center align-items-center"
  >
    <div class="d-flex justify-content-between align-items-center container">
      <h1 class="color-gold my-3">
        <strong>{{ $t("nft.latest", { nftType: nftType }) }}</strong>
      </h1>
      <router-link :to="'nft-all-' + pageType" class="all-tokens">{{
        $t("nft.seeAll")
      }}</router-link>
    </div>
    <div class="nft-carousel">
      <Carousel
        :navigationEnabled="true"
        :navigationClickTargetSize="16"
        navigationPrevLabel=""
        navigationNextLabel=""
        :perPage="1"
        :perPageCustom="[
          [768, 2],
          [1200, 3],
        ]"
        :paginationEnabled="false"
      >
        <Slide v-for="token in nftTokens" :key="token.id">
          <div class="nft-token-card p-2">
            <img
              :src="'../images/nft/' + token.image"
              :alt="token.name"
              class="w-100"
            />
            <div class="card p-2 border-0">
              <div class="row">
                <div class="col-2 pe-0">
                  <img
                    :src="
                      token.owner.avatar == 'default'
                        ? '../images/users/default-avatar.png'
                        : token.owner.avatar
                    "
                    alt="Avatar"
                    class="w-100"
                  />
                </div>
                <div class="col-10">
                  <div class="card-body p-0">
                    <h5 class="card-title m-0">{{ token.name }}</h5>
                    <p class="card-text">
                      <small>{{ token.owner.name }}</small>
                    </p>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-4">
                  <router-link
                    :to="'nft-all-' + pageType + '?show=1'"
                    class="btn btn-sm btn-light"
                    >{{ token.tradeInfo.eb }}
                    {{ token.tradeInfo.cryptoType }}</router-link
                  >
                </div>
                <div class="col-4">
                  <router-link
                    :to="'nft-all-' + pageType + '?show=1'"
                    class="btn btn-sm btn-light"
                    >{{ token.tradeInfo.wt }}
                    {{ token.tradeInfo.cryptoType }}</router-link
                  >
                </div>
                <div class="col-4 text-end">
                  <router-link
                    :to="'nft-all-' + pageType + '?show=1'"
                    class="btn btn-sm btn-light"
                    >{{ token.tradeInfo.og }}
                    {{ token.tradeInfo.cryptoType }}</router-link
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-4 text-center">
                  <small>{{ $t("nft.eb") }}</small>
                </div>
                <div class="col-4 text-center">
                  <small>{{ $t("nft.wt") }}</small>
                </div>
                <div class="col-4 text-center">
                  <small>{{ $t("nft.og") }}</small>
                </div>
              </div>
            </div>
          </div>
        </Slide>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: {
    pageType: String,
  },
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      nftType: "GSG",
      nftTokens: [],
    };
  },
  mounted() {
    this.getNFT();
  },
  methods: {
    getNFT() {
      // 这里应该从API接口获取数据
      switch (this.pageType) {
        case "gema":
          this.nftType = "GEMA";
          this.nftTokens = [
            {
              id: "GEMA00418",
              name: "GEMA Token #00418",
              image: "GEMA-00418.png",
              owner: {
                name: "Hyde",
                avatar: "/images/users/rojas.png",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GEMA00278",
              name: "GEMA Token #00278",
              image: "GEMA-00278.png",
              owner: {
                name: "Vargas",
                avatar: "/images/users/rojas.png",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GEMA00274",
              name: "GEMA Token #00274",
              image: "GEMA-00274.png",
              owner: {
                name: "Reyes",
                avatar: "default",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GEMA00676",
              name: "GEMA Token #00676",
              image: "GEMA-00676.png",
              owner: {
                name: "Rosa",
                avatar: "/images/users/rojas.png",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GEMA00007",
              name: "GEMA Token #00007",
              image: "GEMA-00007.png",
              owner: {
                name: "Page",
                avatar: "/images/users/rojas.png",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GEMA00100",
              name: "GEMA Token #00100",
              image: "GEMA-00100.png",
              owner: {
                name: "Davis",
                avatar: "default",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
          ];
          break;

        default:
          this.nftType = "GSG";
          this.nftTokens = [
            {
              id: "GSG00117",
              name: "GSG Token #00117",
              image: "GSG-00117.png",
              owner: {
                name: "Patrick",
                avatar: "default",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GSG00032",
              name: "GSG Token #00032",
              image: "GSG-00032.png",
              owner: {
                name: "Mcpherson",
                avatar: "default",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GSG00127",
              name: "GSG Token #00127",
              image: "GSG-00127.png",
              owner: {
                name: "Buckner",
                avatar: "default",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GSG00052",
              name: "GSG Token #00052",
              image: "GSG-00052.png",
              owner: {
                name: "Rojas",
                avatar: "/images/users/rojas.png",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GSG00087",
              name: "GSG Token #00087",
              image: "GSG-00087.png",
              owner: {
                name: "Craig",
                avatar: "default",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
            {
              id: "GSG00090",
              name: "GSG Token #00090",
              image: "GSG-00090.png",
              owner: {
                name: "Burton",
                avatar: "default",
              },
              tradeInfo: {
                cryptoType: "ETH",
                eb: "9.61",
                wt: "4.12",
                og: "3.25",
              },
            },
          ];
          break;
      }
    },
  },
  watch: {
    $route() {
      this.getNFT();
    },
    "$i18n.locale": function () {
      this.getNFT();
    },
  },
};
</script>

<style>
.all-tokens {
  color: #1898dd;
  font-size: 1.4rem;
  text-decoration: none;
}
.nft-carousel {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .VueCarousel {
    width: calc(100% - 4.5rem);
    .VueCarousel-slide {
      position: relative;
      background: transparent;
      padding: 1rem 1rem;
      box-sizing: border-box;
      .nft-token-card {
        background: white;
        box-shadow: 0px 0.15rem 1rem 0px #0007481f;
        border-radius: 1.3rem;
        overflow: hidden;
      }
    }
    .VueCarousel-navigation-button {
      color: white;
      background-color: #0fc1cc;
      width: 2rem;
      height: 2rem;
      border-radius: 2rem;
    }
    .VueCarousel-navigation-prev::before,
    .VueCarousel-navigation-next::before {
      content: "";
      border: solid white;
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 3px;
      position: absolute;
    }
    .VueCarousel-navigation-prev::before {
      transform: rotate(135deg);
      -webkit-transform: rotate(135deg);
      left: 50%;
      top: 50%;
      margin-left: -4px;
      margin-top: -4px;
    }
    .VueCarousel-navigation-next::before {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
      left: 50%;
      top: 50%;
      margin-left: -6px;
      margin-top: -4px;
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .nft-carousel {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .VueCarousel {
      width: calc(100% - 200px);
      .VueCarousel-slide {
        position: relative;
        background: transparent;
        padding: 1rem 2rem;
        box-sizing: border-box;
        .nft-token-card {
          background: white;
          box-shadow: 0px 0.3rem 2rem 0px #0007481f;
          border-radius: 1.3rem;
          overflow: hidden;
        }
      }
      .VueCarousel-navigation-button {
        color: white;
        background-color: #0fc1cc;
        width: 3.9rem;
        height: 3.9rem;
        border-radius: 3.9rem;
      }
      .VueCarousel-navigation-prev::before,
      .VueCarousel-navigation-next::before {
        border-width: 0 4px 4px 0;
        padding: 4px;
      }
      .VueCarousel-navigation-prev::before {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
        left: 50%;
        top: 50%;
        margin-left: -6px;
        margin-top: -6px;
      }
      .VueCarousel-navigation-next::before {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        left: 50%;
        top: 50%;
        margin-left: -10px;
        margin-top: -6px;
      }
    }
  }
}
</style>
